import React from 'react';
import { Route } from 'react-router-dom';
import { BindersPage } from './Routes';

export const routes = [<Route key={0} path="/binders" component={BindersPage} />];

export const navigation = [{ name: 'project_literally', link: '/binders', icon: 'Binder' }];
